var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreativitySkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1562 43.1655C69.1562 52.1841 63.879 59.9701 56.244 63.604C55.9455 63.746 55.7503 64.0435 55.7503 64.3741C55.7503 65.5754 55.7503 68.3017 55.7503 68.3017H37.3171L37.3802 65.1489C37.3869 64.8124 37.1908 64.5059 36.8874 64.3601C29.2548 60.693 23.9111 52.1801 23.9111 43.1655C23.9111 30.6714 34.0396 20.543 46.5337 20.543C59.0278 20.543 69.1562 30.6714 69.1562 43.1655Z",
    fill: "#FFD100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8015 40.152C43.626 37.8552 44.5408 35.9102 45.8417 35.8096C47.1426 35.709 48.345 37.4946 48.5205 39.7914C48.6959 42.0882 47.7812 44.0332 46.4803 44.1338C45.1794 44.2344 43.977 42.4488 43.8015 40.152Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.6113,
    y: 68.7456,
    width: 21.7866,
    height: 3.35178,
    rx: 1.67589,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.6113,
    y: 72.8716,
    width: 21.7866,
    height: 3.35178,
    rx: 1.67589,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6604 77.0245C55.6604 78.235 55.422 79.4336 54.9587 80.5519C54.4955 81.6702 53.8166 82.6863 52.9607 83.5422C52.1047 84.3981 51.0886 85.0771 49.9703 85.5403C48.852 86.0035 47.6534 86.2419 46.443 86.2419C45.2325 86.2419 44.0339 86.0035 42.9156 85.5403C41.7973 85.0771 40.7812 84.3981 39.9253 83.5422C39.0694 82.6863 38.3904 81.6702 37.9272 80.5519C37.464 79.4336 37.2256 78.235 37.2256 77.0245L46.443 77.0245H55.6604Z",
    fill: "#ADADAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3183 31.363C40.7797 30.3977 41.8269 30.1362 42.7071 30.4287C43.5873 30.7213 43.8126 31.9722 43.3541 32.94C42.8955 33.9078 41.9207 34.2219 41.0405 33.9293C40.1603 33.6368 39.8598 32.3308 40.3183 31.363Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3877 31.363C48.849 30.3977 49.8962 30.1362 50.7764 30.4287C51.6566 30.7213 51.8819 31.9722 51.4234 32.94C50.9649 33.9078 49.99 34.2219 49.1098 33.9293C48.2296 33.6368 47.9291 32.3308 48.3877 31.363Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5049 15.0691V7",
    stroke: "#FFED9D",
    strokeWidth: 3.22764,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0691 44.1177L11 44.1177",
    stroke: "#FFED9D",
    strokeWidth: 3.22764,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9963 44.1177L82.0654 44.1177",
    stroke: "#FFED9D",
    strokeWidth: 3.22764,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5817 23.1955L19.876 17.4897",
    stroke: "#FFED9D",
    strokeWidth: 3.22764,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4837 61.8705L73.1895 67.5762",
    stroke: "#FFED9D",
    strokeWidth: 3.22764,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4837 23.1955L73.1895 17.4897",
    stroke: "#FFED9D",
    strokeWidth: 3.22764,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5817 61.8705L19.876 67.5762",
    stroke: "#FFED9D",
    strokeWidth: 3.22764,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativitySkills);
export default __webpack_public_path__ + "static/media/Creativity_skills.31f70f4c355d9b4accfc039f5c800d30.svg";
export { ForwardRef as ReactComponent };